import { ButtonProps, IconButton } from '@chakra-ui/react';
import { CloseSmallIcon, HamburgerMenuIcon } from '~/components/icons';

interface Props extends ButtonProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const ToggleIcon: React.FC<Props> = ({
  isOpen,
  onClose,
  onOpen,
  ...props
}) => {
  const Icon = isOpen ? CloseSmallIcon : HamburgerMenuIcon;
  const handleClick = isOpen ? onClose : onOpen;

  return (
    <IconButton
      {...props}
      aria-label={isOpen ? `Close menu` : `Open menu`}
      variant="link"
      onClick={handleClick}
      icon={<Icon color="white" boxSize={6} />}
    />
  );
};
